"use client"

import HomeDetailsWrapperAccordion from "../home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { workScopeStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const baseFieldName = "home.exteriorDoorInstallInfo"

function HomeExteriorDoorInstallForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillExteriorDoorInstallOn = useWatch({ control, name: `${baseFieldName}.goodwillExteriorDoorInstallOn` })
    
    // Watch status field and claimed by field
    const exteriorDoorInstall = useWatch({ control, name: `${baseFieldName}.exteriorDoorInstall` })
    const claimedBy = useWatch({ control, name: `${baseFieldName}.claimedBy` })
    const goodwillExteriorDoorInstall = useWatch({ control, name: `${baseFieldName}.goodwillExteriorDoorInstall` })
    const goodwillExteriorDoorInstallClaimedBy = useWatch({
        control,
        name: `${baseFieldName}.goodwillExteriorDoorInstallClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: exteriorDoorInstall,
        claimedBy,
        claimedByFieldPath: `${baseFieldName}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillExteriorDoorInstall,
        claimedBy: goodwillExteriorDoorInstallClaimedBy,
        claimedByFieldPath: `${baseFieldName}.goodwillExteriorDoorInstallClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillExteriorDoorInstallOn,
    })
    return (
        <HomeDetailsWrapperAccordion 
            heading="Exterior Door Install"
            wrapperClassName="xl:grid-cols-2"
        >
            <FormSelectInput
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Exterior Door Install" toggleName={`${baseFieldName}.goodwillExteriorDoorInstallOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${baseFieldName}.exteriorDoorInstall`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${baseFieldName}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillExteriorDoorInstallOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Exterior Door Install Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${baseFieldName}.goodwillExteriorDoorInstall`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Exterior Door Install Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${baseFieldName}.goodwillExteriorDoorInstallClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormTextInput
                inputGroupProps={{
                    label: "How many exterior doors need replacing?"
                }}
                placeholder="How many exterior doors need replacing?"
                name={`${baseFieldName}.doorsReplacing`}
                type="number"
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "How many Exterior Door/Shutter need trim?"
                }}
                placeholder="How many Exterior Door/Shutter need trim?"
                name={`${baseFieldName}.doorsNeedTrim`}
                type="number"
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Description",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={3}
                placeholder="Describe the exterior door installation work needed"
                name={`${baseFieldName}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeExteriorDoorInstallForm
